import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import DataTable from "../../components/Datatable/DataTable";
import Button from "../../components/Button/Button";
import { AiFillPlusCircle, AiFillMinusCircle } from "react-icons/ai";
import { FaFileExcel } from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import DateTimePicker from "../../components/DateTimePicker/DateTimePicker";
import StringInput from "../../components/Input/StringInput/StringInput";
import moment from "moment";
import Excel from "../../assets/images/excel.svg";
import { getDailyCheckInHistory, exportDailyCheckInHistory } from "../../store/ducks/dailyCheckIn/actions";

class DailyCheckInListHistory extends Component {
  constructor(props) {
    super(props);
    // Get Monday 00:00:00 of current week
    const mondayStart = moment().day(1).format('YYYY/MM/DD') + ' 00:00:00';
    // Get Sunday 23:59:59 of current week
    const sundayEnd = moment().day(1).add(6, 'days').format('YYYY/MM/DD') + ' 23:59:59';
    
    this.state = {
      showCard: true,
      data: [],
      totalRecords: 0,
      activePage: 1,
      limit: 10,
      loading: false,
      searchInput: {
        memberUsername: "",
        startDate: mondayStart,
        endDate: sundayEnd,
      },
    };
  }

  rowNumberFormatter = (rowIndex) => {
    let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
    return <span>{rowNumber}</span>;
  }

  onChangeUsername = (e) => {
    this.setState({
      searchInput: {
        ...this.state.searchInput,
        memberUsername: e.target.value.trim(),
      },
    });
  };

  onChangeDateRange = (e) => {
    const dateRange = e.target.value;
    let startDate = "";
    let endDate = "";
    
    if (dateRange && dateRange.includes(" - ")) {
      const dates = dateRange.split(" - ");
      startDate = dates[0];
      endDate = dates[1];
    }
    
    this.setState({
      searchInput: {
        ...this.state.searchInput,
        startDate: startDate,
        endDate: endDate,
      },
    });
  };

  onSearch = () => {
    this.setState({
      ...this.state,
      loading: true,
    }, () => {
      this.props.getDailyCheckInHistory({
        page: this.state.activePage,
        limit: this.state.limit,
        order: "desc",
        sort: "created_at",
        memberUsername: this.state.searchInput.memberUsername,
        startDate: this.state.searchInput.startDate,
        endDate: this.state.searchInput.endDate,
      });
    });
    
  };

  onExportExcel = () => {
    this.props.exportDailyCheckInHistory({
      memberUsername: this.state.searchInput.memberUsername,
      startDate: this.state.searchInput.startDate,
      endDate: this.state.searchInput.endDate,
      page: this.state.activePage,
      limit: this.state.limit,
    });
  };

  onReset = () => {
    // Get Monday 00:00:00 of current week
    const mondayStart = moment().day(1).format('YYYY/MM/DD') + ' 00:00:00';
    // Get Sunday 23:59:59 of current week
    const sundayEnd = moment().day(1).add(6, 'days').format('YYYY/MM/DD') + ' 23:59:59';
    
    this.setState({
      ...this.state,
      searchInput: {
        memberUsername: "",
        startDate: mondayStart,
        endDate: sundayEnd,
      },
    }, () => this.onSearch());
  };

  onChangePage = (page) => {
    this.setState({
      ...this.state,
      activePage: Number(page),
    }, () => this.onSearch());
  };

  onChangeLimit = (limit) => {
    this.setState({
      ...this.state,
      limit: Number(limit),
    }, () => this.onSearch());
  };

  componentDidMount() {
    // Automatically search with default date range on component mount
    this.onSearch();
  }

  componentDidUpdate(prevProps) {

    if (
      prevProps.listHistory !== this.props.listHistory &&
      this.props.listHistory &&
      this.props.listHistory.data &&
      this.props.listHistory.data.responseCode === 200 &&
      this.props.listHistory.data.data &&
      this.props.listHistory.data.data.result &&
      this.props.listHistory.data.data.result.pagination &&
      this.props.listHistory.data.data.result.row
    ) {

      let { data } = this.props.listHistory;
      if (data) {
        this.setState({
          ...this.state,
          data: this.props.listHistory.data.data.result.row,
          totalRecords: this.props.listHistory.data.data.result.pagination.total_record || 0,
          activePage: this.props.listHistory.data.data.result.pagination.current_page || 1,
          limit: this.props.listHistory.data.data.result.pagination.per_page || 10,
          loading: false,
        });
      }
    }
  }

  render() {
    let { t } = this.props;

    const columns = [
      {
        text: t("global.no"),
        dataField: "no",
        formatter: (cell, row, rowIndex) => this.rowNumberFormatter(rowIndex)
      },
      {
        text: t("member.username"),
        dataField: "username",
        sort: false,
      },
      {
        text: t("global.reward-total-free-spin"),
        dataField: "reward_total_free_spin",
        sort: false,
      },
      {
        text: t("global.reward-credit"),
        dataField: "reward_credit",
        sort: false,
      },
      {
        text: t("global.reward-coin"),
        dataField: "reward_coin",
        sort: false,
      },
      {
        text: t("global.extra-reward-coin"),
        dataField: "extra_reward_coin",
        sort: false,
      },
      {
        text: t("global.extra-reward-credit"),
        dataField: "extra_reward_credit",
        sort: false,
      },
      { 
        text: t("global.extra-reward-total-free-spin"),
        dataField: "extra_reward_total_free_spin",
        sort: false,
      },
      {
        text: t("global.used-credit"),
        dataField: "used_credit",
        sort: false,
      },
      {
        text: t("global.is-recheck-in"),
        dataField: "is_recheck_in_text",
        sort: false
      },
      {
        text: t("global.created-at"),
        dataField: "created_at",
        sort: false,
      }
    ];

    return (
      <Auxiliary>
        <div className="row row-sm">
          <div className="col-xl-12">
            <div className="card card-body">
              <div className="col mt-auto">
                {this.props.loading ? (
                  <Skeleton count={2} />
                ) : (
                  <>
                    <div className={`form-horizontal filter-function row`}>
                      <div className="col-md-3 col-6">
                        <div className="form-group">
                          <label className="font-weight-bolder">
                            {t("global.member-username")}
                          </label>
                          <StringInput
                            id="username"
                            name="username"
                            value={this.state.searchInput.memberUsername}
                            onChange={this.onChangeUsername}
                            className="filter-input"
                            onSearchPress={(e) =>
                              e.key === "Enter" && this.onSearch()
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-3 col-6">
                        <div className="form-group">
                          <label className="font-weight-bolder">
                            {t("global.date-range")}
                          </label>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fas fa-calendar-check"></i>
                              </span>
                            </div>
                            <DateTimePicker
                              id="dateRange"
                              name="dateRange"
                              value={`${this.state.searchInput.startDate} - ${this.state.searchInput.endDate}`}
                              onChange={this.onChangeDateRange}
                              className="form-control filter-input"
                              placeholder={t("global.select-date-range")}
                              range={true}
                              timePicker={true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    {/* New row for buttons */}
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="d-flex">
                          <Button
                            typeButton="button"
                            classValue="btn btn-blue mr-2"
                            idValue="filter"
                            buttonName={t("global.filter")}
                            clicked={() => this.onSearch()}
                          />
                          <Button
                            typeButton="button"
                            classValue="btn btn-secondary mr-2"
                            idValue="reset"
                            buttonName={t("global.reset")}
                            clicked={() => this.onReset()}
                          />
                          <Button
                            typeButton="button"
                            classValue="btn btn-blue"
                            idValue="export"
                            clicked={() => this.onExportExcel()}
                            img={<img className="d-md-inline-block d-none" alt="img" src={Excel} />}
                            buttonName={t("report.export-excel")}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="show-btn" onClick={() => this.toggleCard()}>
                {this.state.showCard ? (
                  <AiFillMinusCircle />
                ) : (
                  <AiFillPlusCircle />
                )}
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header pb-0">
                <div className="d-flex justify-content-between">
                  <h4 className="card-title mg-b-0">
                    {t("global.daily-check-in-list-history")}
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive table-hover datatable">
                 {this.state.loading ? <Skeleton count={10} /> : (
                  <DataTable
                    keyField="no"
                    data={this.state.data}
                    columns={columns}
                    activePage={this.state.activePage}
                    limit={this.state.limit}
                    totalItems={this.state.totalRecords}
                    paginationHandler={(val) => this.onChangePage(val)}
                    sizePerPageHandler={(val) => this.onChangeLimit(val)}
                    classValue="dataTable table-bordered text-justify text-center"
                    loading={this.state.loading}
                  />
                 )}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </Auxiliary>
    );
  }
}

const mapStateToProps = (reduxState) => {
  return {
    listHistory: reduxState.dailyCheckIn?.listHistory
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDailyCheckInHistory: (data) => dispatch(getDailyCheckInHistory(data)),
    exportDailyCheckInHistory: (data) => dispatch(exportDailyCheckInHistory(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(DailyCheckInListHistory));
